import BookingsPortal from './marketplace/BookingsPortal';
import { useNavigate } from 'react-router-dom';

export default function BookingsPage({ user }) {
  const navigate = useNavigate();

  return (
    <BookingsPortal
      user={user}
      onUpgrade={() => navigate(
        `/dashboard/membership?upgrade=silver&from=${encodeURIComponent('/dashboard/bookings')}`
        + `&from_label=${encodeURIComponent('Bookings')}`,
      )}
    />
  );
}
